import { z } from 'zod';
import { requiredString, textWithinLimit } from '@/shared/lib/validation';

/** Проверяет электронную почту для привязки */
export const emailBindingSchema = z.object({
    email: requiredString('Укажите электронную почту')
        .pipe(textWithinLimit(254, 'Электронная почта: не более 254 символов'))
        .pipe(z.email('Укажите корректную электронную почту')),
});

export type EmailBindingFormValues = z.infer<typeof emailBindingSchema>;
